import { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { Divider, Typography } from 'antd';
import { useHistory } from 'react-router-dom';
import Button from '../../Button';

const Container = styled.section`
  border-radius: 5px;
  border-top: 3px solid #bb0665;
  background-color: #fff;
  margin-bottom: 10px;
`;

interface IProps {
  title: string;
  path?: string;
  children: ReactNode;
}

const { Title } = Typography;

const Section: FC<IProps> = ({
  title,
  path,
  children,
}) => {
  const history = useHistory();

  return (
    <div>
      <div className='comm-bx__between mt-2'>
        <h2 className='sub-title'>{title}</h2>
        {path &&
          <div className='comm-btn__area'>
            <Button
              className="btn-basic pink"
              text="More"
              onClick={() => history.push(path)}
            />        
          </div>
        }
      </div>
      {children}
    </div>
  );
};

export default Section;
